import React, { useState, useEffect, useRef } from "react"
import Element from "@bappweb/element"
import List from "@bappweb/list"
import "../assetsv2/style.scss"
import "../../../../../assets/styles/style.scss"
import { useAppSelector } from "../../../config/hook"
import Block from "@bappweb/block"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"

const SssList = () => {
  const [faqText, setFaqText] = useState<any[]>([]);
  const sessionData = useAppSelector((state) => state.sessionData.response)

  useEffect(() => {
    if (sessionData?.configList  && !isNullOrEmpty(getConfigValue(sessionData?.configList, "PosBasvuru.Landing.Faq"))) {
      setFaqText(JSON.parse(getConfigValue(sessionData?.configList, "PosBasvuru.Landing.Faq")))
    }
  }, [sessionData])

  return (
    <Block type="section" className="container accordion-parent-container center-section">
      <Block className="accordion-container">
        <Element type="h2">Bilmem gereken başka neler var?</Element>
        <List
          accordion
          accordionCollapsible
          activeItem={0}
          custom={false}
          disabled={false}
          expandOnlyOne
          withPadding
          withoutBorder={false}
        >
          {faqText && faqText.map((item: any, index) => {
            return (
              <List.Item
                accordion={false}
                accordionCollapsible
                disabled={false}
                preventDefault
                title={item?.title}
                withPadding={true}
                key={index}
              >
                <Block dangerouslySetInnerHTML={{ __html: item?.data }} />
              </List.Item>
            )
          })}
        </List>
      </Block>
    </Block>
  )
}

export default SssList
